export const BUILD_ID = 'd9d55f2e-971c-4b62-b7b0-7b0a7732539c';
export const ENV = 'dev';
